<ion-grid class="prover-timepicker" [ngClass]="{ disabled: disabled }">
  <ion-row class="ion-align-content-center" id="{{ id }}">
    <ion-col class="ion-align-self-center">
      <ion-label position="stacked">
        <h3 *ngIf="isLabel">{{ labelName | translate}} <ion-text *ngIf="required" color="danger">*</ion-text></h3>

        <p [ngStyle]="isColor">
          {{ timeValue ? timeValue : ('Não informado' | translate ) }}
        </p>
      </ion-label>
    </ion-col>

    <ion-col size="2" class="ion-align-self-center icon-clock">
      <i class="fa-thin fa-clock"></i>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-modal *ngIf="!disabled" trigger="{{ id }}" [initialBreakpoint]="1" [breakpoints]="[0, 1]" handleBehavior="cycle">
  <ng-template>
    <ion-header class="extendido">
      <ion-toolbar>
        <ion-title>{{ labelName | translate}}</ion-title>
      </ion-toolbar>
    </ion-header>

    <ion-datetime
      presentation="time"
      [(ngModel)]="timeValue"
      [ngModelOptions]="{ standalone: true }"
      doneText="{{ 'Confirmar' | translate }}"
      cancelText="{{ 'Cancelar' | translate }}"
      [showDefaultButtons]="true"
      (ionChange)="changeTime($event)"
      [locale]="idioma"
      [disabled]="disabled"
    ></ion-datetime>
  </ng-template>
</ion-modal>
